module.exports = __webpack_public_path__ + "img/2.bfa7a0f4.webp";